import { render, staticRenderFns } from "./app-update.vue?vue&type=template&id=cef13ad8&scoped=true"
import script from "./app-update.vue?vue&type=script&lang=js"
export * from "./app-update.vue?vue&type=script&lang=js"
import style0 from "./app-update.vue?vue&type=style&index=0&id=cef13ad8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef13ad8",
  null
  
)

export default component.exports